import { render } from "./SenderDetails.vue?vue&type=template&id=01375c74&scoped=true&ts=true"
import script from "./SenderDetails.vue?vue&type=script&lang=ts"
export * from "./SenderDetails.vue?vue&type=script&lang=ts"

import "./SenderDetails.vue?vue&type=style&index=0&id=01375c74&scoped=true&lang=css"
/* custom blocks */
import block0 from "./SenderDetails.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01375c74"]])

export default __exports__